import { render, staticRenderFns } from "./siteGroup__list.vue?vue&type=template&id=b67b484c"
import script from "./siteGroup__list.vue?vue&type=script&lang=js"
export * from "./siteGroup__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports